import React from 'react'
import { sportableColors } from '../../../constants/sportableColors'

export interface PassSummaryIconProps {
  scale?: number
  color?: string
}

export const PassSummaryIcon: React.FC<PassSummaryIconProps> = ({
  scale = 1,
  color = sportableColors.colors.sportableGreyDark
}) => {
  return (
    <svg
      width={34 * scale}
      height={34 * scale}
      viewBox='0 0 36 37'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.2716 5.92205e-05C15.9646 0.000875482 15.6417 0.0125888 15.3063 0.0356482C17.0326 1.2149 18.7193 2.81502 19.9625 4.4526C20.0191 3.70989 20.0096 3.03284 19.9476 2.45635C19.8444 1.49741 19.5564 0.814321 19.3491 0.617724C19.1418 0.421005 18.4217 0.147843 17.4109 0.0500145C17.1582 0.0255266 16.8872 0.00960947 16.6006 0.00320181C16.4931 0.000753029 16.3833 -0.000267284 16.2716 5.92205e-05ZM12.2906 0.515528C9.76863 1.14058 7.01808 2.38705 4.7536 4.5348C2.49708 6.69226 1.19141 9.31536 0.537806 11.7172C2.01066 13.6652 5.64379 17.1089 7.68068 18.4847C10.2031 17.8595 12.9541 16.6128 15.2188 14.4645C17.4835 12.3161 18.7977 9.70639 19.4567 7.3136C17.9988 5.37131 14.3381 1.89852 12.2906 0.515528ZM11.8776 1.33546L12.224 1.99255C11.7113 2.23572 11.2297 2.47231 10.7755 2.70556L11.031 3.20519L10.3343 3.52586L10.0977 3.06345C9.5169 3.37755 8.9817 3.68911 8.48659 4.00611L8.77592 4.41812L8.13143 4.82543L7.85337 4.42946C7.32892 4.79625 6.84835 5.17512 6.39936 5.57851L6.81768 5.97534L6.27016 6.49473L5.85185 6.09794C5.42764 6.52297 5.02903 6.97755 4.64324 7.47375L5.08165 7.74222L4.66157 8.35931L4.19671 8.0746C3.87081 8.5324 3.5505 9.02636 3.22783 9.56118L3.79857 9.81234L3.47276 10.4788L2.84935 10.2045C2.59491 10.6487 2.33703 11.1199 2.07167 11.6234L1.37899 11.2949C1.63907 10.8014 1.89398 10.336 2.14709 9.89548L1.70653 9.70162L2.03239 9.03522L2.52698 9.25275C2.8679 8.68965 3.20847 8.16766 3.55652 7.68255L3.02588 7.35747L3.44587 6.74038L4.005 7.0828C4.42344 6.54611 4.85707 6.05337 5.31905 5.59255L4.89342 5.18871L5.44094 4.66932L5.86665 5.07313C6.351 4.63622 6.86879 4.22597 7.43252 3.83012L7.05194 3.28837L7.69642 2.88105L8.06419 3.40469C8.58743 3.06663 9.15129 2.73609 9.76089 2.40493L9.48425 1.86416L10.181 1.54349L10.438 2.04598C10.8919 1.81183 11.3705 1.57597 11.8776 1.33546ZM0.0370172 14.5847C-0.0178373 15.3135 -0.00974892 15.9781 0.0482032 16.5457C0.146167 17.5038 0.426721 18.1888 0.625487 18.3849C0.835957 18.5814 1.55358 18.8528 2.5605 18.9503C3.1682 19.009 3.88186 19.0182 4.66484 18.9645C2.95166 17.7942 1.27737 16.2093 0.0370172 14.5847Z'
        fill={color}
      />
      <path
        opacity='0.5'
        d='M9 19.1111C9 13.8736 9 11.2542 10.6278 9.62778C12.2542 8 14.8736 8 20.1111 8H22.8889C28.1264 8 30.7458 8 32.3722 9.62778C34 11.2542 34 13.8736 34 19.1111V24.6667C34 29.9042 34 32.5236 32.3722 34.15C30.7458 35.7778 28.1264 35.7778 22.8889 35.7778H20.1111C14.8736 35.7778 12.2542 35.7778 10.6278 34.15C9 32.5236 9 29.9042 9 24.6667V19.1111Z'
        stroke={color}
        strokeWidth='2.25'
      />
      <path
        d='M16.0002 20.6296H27.1113M16.0002 24.7963H21.0186H27.1113M16.0002 16H27.1113M16 29.1667H22.0186'
        stroke={color}
        strokeWidth='2.25'
        strokeLinecap='round'
      />
    </svg>
  )
}
